import React, { useEffect, useState } from 'react'
import { ProgressBar } from '@/components/quiz/ProgressBar'

export const SpecialOffer = ({ percentDiscount }: { percentDiscount: number }) => {
  const [endTime, setEndTime] = useState<Date | null>(null)
  const [timeDifference, setTimeDifference] = useState<number | null>(600000)

  const startTimer = () => {
    if (endTime) {
      const intervalId = setInterval(() => {
        const currentTime = new Date()
        const difference = endTime.getTime() - currentTime.getTime()
        if (difference <= 0) {
          clearInterval(intervalId)
          setTimeDifference(0)
        } else {
          setTimeDifference(difference)
        }
      }, 1000)
      return () => clearInterval(intervalId)
    }
  }

  useEffect(() => {
    const currentTime = new Date()
    const endTime = new Date(currentTime.getTime() + 10.01 * 60 * 1000)
    setEndTime(endTime)
  }, [])

  useEffect(() => {
    if (endTime) {
      const currentTime = new Date()
      const difference = endTime.getTime() - currentTime.getTime()
      if (difference > 0) {
        startTimer()
      } else {
        setTimeDifference(0)
      }
    }
  }, [endTime])

  useEffect(() => {
    if (timeDifference === 0) {
      console.log('ALl')
    }
  }, [timeDifference])

  const minutes = Math.floor((timeDifference ?? 0) / (1000 * 60))
  const seconds = Math.floor(((timeDifference ?? 0) % (1000 * 60)) / 1000)
  return (
    <div className="bg-[#A10D860F] rounded-3xl py-4 px-6">
      <div className="flex justify-between items-center mb-4 gap-2">
        <p className="font-semibold text-[#A10D86]">
          Special {percentDiscount}% offer reserved for:
        </p>
        <div className="flex text-[#A10D8666] font-percent gap-1 items-center font-bold tracking-[-1px] font-j">
          <span className="text-[#A10D86]">
            {minutes < 10 ? '0' : ''}
            {minutes}
          </span>
          :
          <span className="text-[#A10D86]">
            {seconds < 10 ? '0' : ''}
            {seconds}
          </span>
        </div>
      </div>
      <ProgressBar purple={true} currentStep={600 - minutes * 60 - seconds} lastStep={600} />
    </div>
  )
}
